import henryIrish from "../assets/avatars/henry_irish.jpg";
import jennyZhan from "../assets/avatars/jenny_zhan.jpg";
import jamesEvans from "../assets/avatars/james_evans.jpg";
import phoebeScott from "../assets/avatars/phoebe_scott.jpg";

const AVATAR_URLS: Record<string, string> = {
  "Henry Irish": henryIrish,
  "Jenny Zhan": jennyZhan,
  "James Evans": jamesEvans,
  "Phoebe Scott": phoebeScott,
};

export function getAvatarUrl(name: string): string | undefined {
  return AVATAR_URLS[name];
}
